import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "title" }
const _hoisted_2 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_3 = { class: "extra" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, _mergeProps(_ctx.$attrs, { class: _ctx.classNames }), {
    default: _withCtx(() => [
      (_ctx.title || _ctx.$slots.title)
        ? _renderSlot(_ctx.$slots, "header", { key: 0 }, () => [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "title", {}, () => [
                _createElementVNode("h3", null, _toDisplayString(_ctx.title), 1)
              ])
            ]),
            (_ctx.title || _ctx.$slots.subtitle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _renderSlot(_ctx.$slots, "subtitle", {}, () => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.subtitle), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "extra")
            ])
          ])
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}